import React from "react";
import DocumentLegal from "../site/DocumentLegal";

function Terms() {
  return (
    <DocumentLegal>
      <h1>Conditions Générales d'Utilisation</h1>
      <p className="gs-doc-date">Dernière mise à jour : octobre 2026</p>

      <section>
        <h2>Article 1 – Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès
          et l'utilisation de l'application mobile <strong>GymNote</strong> (iOS et
          Android) et du site web <strong>gymnote.fr</strong>, édités par Mathis Le
          Berrigaud (ci-après « GymNote »). Toute utilisation de l'application
          implique l'acceptation pleine et entière des présentes CGU.
        </p>
      </section>

      <section>
        <h2>Article 2 – Description du service</h2>
        <p>
          GymNote est une application de suivi sportif permettant d'enregistrer
          des séances d'entraînement, de suivre ses performances, ses mensurations
          corporelles, de planifier ses séances et de partager ses progrès avec
          ses amis et/ou coach.
        </p>
        <p>
          Gym'Coach, inclus dans les offres GymNote+ et GymNote Pro, propose pour
          chaque série une charge, un nombre de répétitions et un objectif calculés
          à partir de l'historique d'entraînement. Ces propositions sont indicatives :
          elles ne constituent ni un avis médical ni un programme personnalisé établi
          par un professionnel, et chaque utilisateur reste seul juge de ses charges.
        </p>
        <p>
          L'application est utilisable en mode hors ligne. La synchronisation des
          données sur nos serveurs nécessite la création d'un compte et une connexion
          internet.
        </p>
      </section>

      <section>
        <h2>Article 3 – Création de compte</h2>
        <p>
          La création d'un compte est gratuite et requiert une adresse e-mail valide,
          un prénom et un mot de passe. Vous pouvez également vous connecter via
          Google Sign-In ou Sign in with Apple. Vous êtes responsable de la
          confidentialité de vos identifiants.
        </p>
        <p>
          Vous vous engagez à fournir des informations exactes et à les maintenir
          à jour. Un seul compte par personne est autorisé.
        </p>
      </section>

      <section>
        <h2>Article 4 – Abonnements</h2>

        <h3>4.1 Plans disponibles</h3>
        <p>
          L'utilisation de base de GymNote est gratuite. Un compte gratuit permet
          aussi de suivre jusqu'à 3 élèves. Deux offres payantes sont proposées :
        </p>
        <ul>
          <li>
            <strong>GymNote+</strong>, l'offre sportive : Gym'Coach sur toutes vos
            séances.
          </li>
          <li>
            <strong>GymNote Pro</strong>, l'offre coach : jusqu'à 100 élèves, le
            dashboard Coach web et Gym'Coach, pour vos séances comme pour la
            préparation des fiches de vos élèves.
          </li>
        </ul>
        <p>
          Un abonnement couvre les séances de son titulaire. L'abonnement d'un coach
          ne donne pas accès à Gym'Coach sur les séances de ses élèves, et
          l'abonnement d'un élève ne le donne pas à son coach. Les consignes écrites
          par le coach restent visibles par l'élève sans abonnement. Un essai
          gratuit peut être proposé ; ses conditions sont indiquées dans
          l'application.
        </p>

        <h3>4.2 Prix et facturation</h3>
        <p>
          Les abonnements se souscrivent uniquement depuis l'application mobile, via
          l'App Store (iOS) ou Google Play (Android), qui en assurent le paiement. Leurs
          prix sont affichés dans l'application avant tout achat, toutes taxes
          comprises. Les abonnements sont proposés en formule mensuelle ou annuelle.
        </p>

        <h3>4.3 Renouvellement automatique</h3>
        <p>
          Les abonnements se renouvellent automatiquement à leur échéance (mensuelle
          ou annuelle) sauf résiliation de votre part au moins 24 heures avant la
          fin de la période en cours. Le renouvellement est effectué au même prix,
          sauf notification préalable de modification tarifaire.
        </p>

        <h3>4.4 Résiliation</h3>
        <p>
          Vous pouvez résilier votre abonnement à tout moment depuis :
        </p>
        <ul>
          <li>Les paramètres de votre compte App Store (iOS) ou Google Play (Android)</li>
          <li>L'application GymNote : Profil → Abonnement → Gérer l'abonnement</li>
        </ul>
        <p>
          La résiliation prend effet à la fin de la période d'abonnement en cours.
          Aucun remboursement n'est effectué pour la période déjà payée. Les fiches
          Gym'Coach déjà calculées restent consultables après la fin de
          l'abonnement ; elles ne peuvent plus être recalculées.
        </p>

        <h3>4.5 Droit de rétractation</h3>
        <p>
          Conformément à l'article L221-28 du Code de la consommation, le droit de
          rétractation ne s'applique pas aux contenus numériques dont l'exécution
          a commencé avec votre accord.
        </p>
      </section>

      <section>
        <h2>Article 5 – Contenu utilisateur</h2>

        <h3>5.1 Vos données sportives</h3>
        <p>
          Vous conservez la propriété entière de vos données sportives (séances,
          exercices, mensurations). GymNote ne revendique aucun droit de propriété
          sur ces données.
        </p>

        <h3>5.2 Commentaires et réactions</h3>
        <p>
          L'application permet de laisser des réactions (👏 bravo, 🔥 feu, 💪
          force) et des commentaires textes sur les séries de vos amis. En publiant
          un commentaire, vous vous engagez à :
        </p>
        <ul>
          <li>Ne pas publier de contenu offensant, discriminatoire, menaçant ou illégal.</li>
          <li>Ne pas usurper l'identité d'autrui.</li>
          <li>Ne pas diffuser de contenu à caractère publicitaire non sollicité.</li>
        </ul>
        <p>
          GymNote se réserve le droit de supprimer tout commentaire non conforme
          sans préavis.
        </p>
      </section>

      <section>
        <h2>Article 6 – Fonctionnalités sociales</h2>

        <h3>6.1 Relations amicales</h3>
        <p>
          Vous pouvez ajouter des amis via un système de code d'invitation. Une
          relation amicale est symétrique : chaque partie peut voir certaines
          données sportives de l'autre (progressions récentes, records). Vous pouvez
          mettre fin à une relation à tout moment depuis l'application.
        </p>

        <h3>6.2 Visibilité des données</h3>
        <p>
          Seules vos données récentes (progressions, records) sont visibles par
          vos amis dans leur fil d'actualité. Vos mensurations et l'intégralité
          de votre historique d'entraînement ne sont jamais partagés avec vos amis
          (uniquement avec votre coach si relation de coaching active).
        </p>

        <h3>6.3 Signalement de contenu</h3>
        <p>
          Tout utilisateur peut signaler un commentaire inapproprié via le bouton
          de signalement (icône drapeau) présent sur chaque commentaire. Le
          signalement est transmis à notre équipe de modération qui examinera
          le contenu et pourra prendre les mesures appropriées (suppression du
          commentaire, avertissement, suspension ou suppression du compte
          contrevenant). Le signalement est confidentiel : l'auteur du commentaire
          n'est pas notifié de votre signalement.
        </p>
      </section>

      <section>
        <h2>Article 7 – Relation coach / élève</h2>
        <p>
          Tout utilisateur peut inviter des élèves via un code d'invitation unique,
          dans la limite de son offre (3 élèves sans abonnement GymNote Pro, 100 avec). En acceptant l'invitation, l'élève
          autorise son coach à consulter et modifier ses séances d'entraînement.
          L'élève peut mettre fin à la relation à tout moment depuis Profil →
          Partenaires.
        </p>
        <p>
          Le coach s'engage à utiliser les données de ses élèves dans le seul
          cadre de l'accompagnement sportif et à respecter leur confidentialité.
        </p>
      </section>

      <section>
        <h2>Article 8 – Obligations de l'utilisateur</h2>
        <p>Il est interdit :</p>
        <ul>
          <li>D'utiliser l'application à des fins illicites ou contraires à l'ordre public.</li>
          <li>De tenter de contourner les mesures de sécurité de l'application.</li>
          <li>D'accéder aux données d'autres utilisateurs sans leur consentement.</li>
          <li>De créer des comptes multiples ou des comptes fictifs.</li>
          <li>De perturber le fonctionnement des serveurs.</li>
        </ul>
      </section>

      <section>
        <h2>Article 9 – Disponibilité du service</h2>
        <p>
          GymNote s'efforce d'assurer la disponibilité du service 24h/24, 7j/7,
          sans garantie de continuité. Des interruptions peuvent survenir pour
          maintenance ou en cas de force majeure. GymNote ne saurait être tenu
          responsable de toute perte de données liée à une interruption de service.
          L'application fonctionnant en mode hors ligne, vos données locales
          restent accessibles en cas d'indisponibilité du serveur.
        </p>
      </section>

      <section>
        <h2>Article 10 – Propriété intellectuelle</h2>
        <p>
          L'application GymNote, son design, son code source, ses pictogrammes
          et son contenu sont protégés par le droit de la propriété intellectuelle.
          Toute reproduction, modification ou exploitation non autorisée est
          strictement interdite.
        </p>
      </section>

      <section>
        <h2>Article 11 – Limitation de responsabilité</h2>
        <p>
          GymNote est un outil de suivi sportif et ne constitue pas un avis médical.
          Consultez un professionnel de santé avant de débuter ou modifier votre
          programme d'entraînement. GymNote décline toute responsabilité pour
          les dommages corporels pouvant résulter de l'utilisation de l'application.
        </p>
      </section>

      <section>
        <h2>Article 12 – Suppression de compte</h2>
        <p>
          Vous pouvez supprimer votre compte à tout moment depuis Profil → Compte
          → Supprimer mon compte. Cette action supprime définitivement et
          irréversiblement toutes vos données (séances, exercices, mensurations,
          commentaires, réactions). Les données de facturation sont conservées
          conformément aux obligations légales.
        </p>
      </section>

      <section>
        <h2>Article 13 – Modification des CGU</h2>
        <p>
          GymNote se réserve le droit de modifier les présentes CGU. Toute
          modification vous sera notifiée via l'application. La poursuite de
          l'utilisation de l'application après notification vaut acceptation des
          nouvelles CGU.
        </p>
      </section>

      <section>
        <h2>Article 14 – Droit applicable et litiges</h2>
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige,
          une solution amiable sera recherchée en priorité. À défaut, vous pouvez
          recourir au médiateur de la consommation désigné : <strong>CM2C</strong>,
          14 rue Saint-Jean, 75017 Paris —{" "}
          <a href="https://www.cm2c.net" target="_blank" rel="noreferrer">www.cm2c.net</a>.
        </p>
      </section>

      <section>
        <h2>Article 15 – Contact</h2>
        <p>
          Pour toute question :{" "}
          <a href="mailto:contact@gymnote.fr">contact@gymnote.fr</a>
        </p>
      </section>
    </DocumentLegal>
  );
}

export default Terms;
